import * as Yup from 'yup';

export const chatSchema = Yup.object().shape({
  message: Yup.string().max(250).required('Required'),
});
